<template>
  <div class="min-h-screen bg-gray-50">
    <!-- Сайдбар -->
    <div class="print:hidden">
      <Sidebar
        :is-open="sidebarOpen"
        @close="sidebarOpen = false"
      />
    </div>

    <!-- Основная область -->
    <div class="lg:pl-64 print:pl-0">
      <!-- Верхняя навигация -->
      <div class="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8 print:hidden">
        <!-- Кнопка меню для мобильных -->
        <button
          type="button"
          class="-m-2.5 p-2.5 text-gray-700 lg:hidden"
          @click="sidebarOpen = true"
        >
          <Bars3Icon class="h-6 w-6" />
        </button>

        <!-- Разделитель -->
        <div class="h-6 w-px bg-gray-200 lg:hidden" />

        <!-- Заголовок страницы -->
        <div class="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
          <div class="flex flex-1 items-center">
            <slot name="header">
              <h1 class="text-xl font-semibold text-gray-900">
                Dashboard
              </h1>
            </slot>
          </div>

          <!-- Профиль пользователя -->
          <div class="flex items-center gap-x-4 lg:gap-x-6">
            <!-- Уведомления -->
            <button
              type="button"
              class="-m-2.5 p-2.5 text-gray-400 hover:text-gray-500"
            >
              <BellIcon class="h-6 w-6" />
            </button>

            <!-- Разделитель -->
            <div class="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-200" />

            <!-- Меню профиля -->
            <Menu as="div" class="relative">
              <MenuButton class="-m-1.5 flex items-center p-1.5">
                <img
                  class="h-8 w-8 rounded-full bg-gray-50"
                  :src="userAvatar"
                  :alt="user?.full_name || user?.username"
                />
                <span class="hidden lg:flex lg:items-center">
                  <span class="ml-4 text-sm font-semibold leading-6 text-gray-900">
                    {{ user?.full_name || user?.username }}
                  </span>
                  <ChevronDownIcon class="ml-2 h-5 w-5 text-gray-400" />
                </span>
              </MenuButton>

              <MenuItems class="absolute right-0 z-10 mt-2.5 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">
                <MenuItem v-slot="{ active }">
                  <button
                    @click="showProfile = true"
                    :class="[active ? 'bg-gray-50' : '', 'block px-3 py-1 text-sm leading-6 text-gray-900 w-full text-left']"
                  >
                    Профиль
                  </button>
                </MenuItem>
                <MenuItem v-slot="{ active }">
                  <button
                    @click="handleLogout"
                    :class="[active ? 'bg-gray-50' : '', 'block px-3 py-1 text-sm leading-6 text-gray-900 w-full text-left']"
                  >
                    Выйти
                  </button>
                </MenuItem>
              </MenuItems>
            </Menu>
          </div>
        </div>
      </div>

      <!-- Основной контент -->
      <main class="py-8">
        <div class="px-4 sm:px-6 lg:px-8">
          <slot />
        </div>
      </main>
    </div>

    <!-- Модальное окно профиля -->
    <ProfileModal
      v-if="showProfile"
      @close="showProfile = false"
    />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import {
  Bars3Icon,
  BellIcon,
  ChevronDownIcon
} from '@heroicons/vue/24/outline'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { useAuthStore } from '@/stores/auth'
import Sidebar from './Sidebar.vue'
import ProfileModal from '../modals/ProfileModal.vue'

const router = useRouter()
const authStore = useAuthStore()

// Состояние
const sidebarOpen = ref(false)
const showProfile = ref(false)

// Computed
const user = computed(() => authStore.user)
const userAvatar = computed(() => {
  // Генерируем аватар на основе имени пользователя
  const name = user.value?.full_name || user.value?.username || 'U'
  const initial = name.charAt(0).toUpperCase()
  return `https://ui-avatars.com/api/?name=${initial}&background=3b82f6&color=ffffff&size=32`
})

// Методы
const handleLogout = async () => {
  await authStore.logout()
  router.push('/login')
}
</script>